import type { LinkMouseEvent } from "@/hooks/analytics/types";

import { useSegmentAnalytics } from "./useSegmentAnalytics";

type LinkClickEvent = {
  event: LinkMouseEvent;
  country?: string;
  program?: string;
  link_url?: string;
};

export const useTriageHistoryPageAnalytics = () => {
  const {
    trackLinkClickEvent,
    trackExternalLinkClickEvent,
    trackMenuClickEvent,
  } = useSegmentAnalytics();

  const trackSignUpLinkClickEvent = (event: LinkMouseEvent) =>
    trackLinkClickEvent({
      event,
      label: "Sign up for another program",
      location: "Triage summary",
      extraProperties: {
        event_type: "Click",
      },
    });

  const trackViewAppSummaryProfileMenuEvent = (event: LinkMouseEvent) =>
    trackMenuClickEvent({
      event,
      label: "View application summary",
      location: "Profile menu",
      extraProperties: {
        event_type: "Menu clicked",
      },
    });

  const trackContinueApplicationLinkClickEvent = ({
    event,
    country,
    program,
    link_url,
  }: LinkClickEvent) =>
    trackExternalLinkClickEvent({
      event,
      label: "Complete application",
      location: "Triage Summary",
      extraProperties: {
        country_selected: country,
        program_selected: program,
        event_type: "Extneral link clicked",
        link_url,
      },
    });

  return {
    trackSignUpLinkClickEvent,
    trackViewAppSummaryProfileMenuEvent,
    trackContinueApplicationLinkClickEvent,
  };
};
